"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('bsc', [
    new Token_1.default('bnb', 'BNB', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} BNB', 'icon/bnb.svg'),
    new Token_1.default('ether', 'ETH', 'bifi', 1, '0x2170ed0880ac9a755fd29b2688956bd959f933f8', '', false, true, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 2, '0x55d398326f99059ff775485246999027b3197955', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('dai', 'DAI', 'bifi', 3, '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3', '', false, true, false, [], '{} DAI', 'icon/dai.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d', '', false, true, false, [], '{} USDC', 'icon/usdc.svg'),
    new Token_1.default('btcb', 'BTCB', 'bifi', 5, '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', '', false, true, false, [], '{} BTCB', 'icon/btcb.svg'),
    new Token_1.default('busd', 'BUSD', 'bifi', 6, '0xe9e7cea3dedca5984780bafc599bd69add087d56', '', false, true, false, [], '{} BUSD', 'icon/busd.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x1378e33a09d8bd8e449CFD8A5aBCa0439286d645', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'bnb'),
    new Handler_1.default(1, 'ether'),
    new Handler_1.default(2, 'usdt'),
    new Handler_1.default(3, 'dai'),
    new Handler_1.default(4, 'usdc'),
    new Handler_1.default(5, 'btcb'),
    new Handler_1.default(6, 'busd')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionStatus(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0xEA0C08aA00F1e890A618bE400Cb0e1aDa52926d5'),
    new EntryPoint_1.default('xBifi', '0xeEe856DAd367a95F0F4f1756392b331Ff3C85894'),
    new EntryPoint_1.default('xBifi.factory', '0xBCc4468b7Dc953B5ed81fe937DE11E6da0Ea7D34')
], 3000);
//# sourceMappingURL=bsc.js.map